"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewPaymentResult_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var NewPaymentResult_Factory = /** @class */ (function () {
    function NewPaymentResult_Factory() {
    }
    NewPaymentResult_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {};
        return result;
    };
    NewPaymentResult_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {};
        return result;
    };
    return NewPaymentResult_Factory;
}());
exports.NewPaymentResult_Factory = NewPaymentResult_Factory;
